import { Button } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { AuctionMemberPageStatus } from '../../../enums/AuctionMemberPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { AuctionHaltButtonProps } from './interface'

export const AuctionHaltButton = ({ record }: AuctionHaltButtonProps) => {
  const { setCurrentAuction, toggleHaltFormVisible } = useAuctionListStore(
    state => pick(state, ['setCurrentAuction', 'toggleHaltFormVisible'])
  )

  const handleClick = () => {
    setCurrentAuction(record)
    toggleHaltFormVisible(true)
  }

  return record.status === AuctionMemberPageStatus.WAIT_ENTRUST_CONFIRM ||
    record.status === AuctionMemberPageStatus.HALT_FAIL ? (
    <Button danger type='link' onClick={handleClick}>
      终止交易
    </Button>
  ) : null
}
